<template>
  <div id="user-types-modal" class="uk-modal-container" uk-modal>
    <div class="uk-modal-dialog">
      <button class="uk-modal-close-full uk-close-large" type="button" uk-close></button>
      <div class="uk-modal-header">
        <h2 class="uk-modal-title">{{ $t('modals.guestVsUser.title') }}</h2>
      </div>
      <div class="uk-modal-body">
        <div v-html="$t('modals.guestVsUser.intro')"></div>
        <div class="uk-grid uk-grid-small uk-child-width-1-2@m" uk-grid uk-height-match="target: > * > * > .uk-card-body">
          <div>
            <div class="uk-card uk-card-hover">
              <div class="uk-card-header">
                <h3 class="uk-card-title">{{ $t('modals.guestVsUser.options.guest.title') }}</h3>
              </div>
              <div class="uk-card-body" v-html="$t('modals.guestVsUser.options.guest.options')"></div>
              <div class="uk-card-footer">
                <button class="uk-button uk-button-default uk-modal-close" type="button">{{ $t('modals.guestVsUser.options.guest.buttons.guest') }}</button>
              </div>
            </div>
          </div>
          <div>
            <div class="uk-card uk-card-hover">
              <div class="uk-card-header">
                <h3 class="uk-card-title">{{ $t('modals.guestVsUser.options.user.title') }}</h3>
              </div>
              <div class="uk-card-body" v-html="$t('modals.guestVsUser.options.user.options')"></div>
              <div class="uk-card-footer">
                <a href="#account-modal" class="uk-button uk-button-primary uk-margin-small-right" uk-toggle>{{ $t('user.account.create.menu') }}</a>
                <a href="#logon-modal" class="uk-button uk-button-default" uk-toggle>{{ $t('user.login.menu') }}</a>
              </div>
            </div>
          </div>
        </div>
        <div v-html="$t('gdpr', {opcoEmail})" class="uk-margin-medium-top"></div>
      </div>
      <div class="uk-modal-footer">
        <label><input class="uk-checkbox" type="checkbox" v-model="dontShowGuestVsUserModal"> {{ $t('modals.guestVsUser.dontShowAnymore') }}</label>
        <button class="uk-button uk-button-default uk-modal-close uk-float-right" type="button">{{ $t('buttons.close') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { parseCookies } from '@/utils/qdev'

export default {
  data () {
    return {
      dontShowCookie: 'dontShowGuestVsUserModal'
    }
  },

  computed: {
    ...mapGetters([
      'userIsGuest',
      'opcoEmail'
    ]),

    dontShowGuestVsUserModal: {
      get () {
        const cookies = parseCookies()

        return !!cookies[this.dontShowCookie]
      },

      set (value) {
        if (value) {
          document.cookie = this.dontShowCookie + '=true; expires=Fri, 31 Dec 9999 23:59:59 GMT; SameSite=lax' + (process.env.NODE_ENV !== 'development' ? '; secure' : '')
        } else {
          document.cookie = this.dontShowCookie + '=false; expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=lax' + (process.env.NODE_ENV !== 'development' ? '; secure' : '')
        }
      }
    }
  },

  mounted () {
    const cookies = parseCookies()

    if (this.userIsGuest && !cookies[this.dontShowCookie]) {
      const modal = document.getElementById('user-types-modal')

      uikit.modal(modal).show()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/_layout/guestVsUserModal.vue